import { render, staticRenderFns } from "./AddNewWidget.vue?vue&type=template&id=04507493"
import script from "./AddNewWidget.vue?vue&type=script&lang=js"
export * from "./AddNewWidget.vue?vue&type=script&lang=js"
import style0 from "./AddNewWidget.vue?vue&type=style&index=0&id=04507493&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports